import styled from 'styled-components';
import {flexUnit} from '../../global-styles/mixins.js';

const StyledFormOverlay = styled.div`
  position: fixed;
  bottom: 0;
  padding: 30px 0;
  height: 100%;
  width: 100%;
  z-index: 10;
  background-color: rgba(0,0,0,0.5);
  overflow-y: auto;
  transform: translateY(100%);
  .overlay--wrap {
    position: relative;
    width: 66.66%;
    padding-right: 64px;
    padding-left: 64px;
    margin: 0 auto;
    background-color: #fff;
    padding-top: 80px;
    padding-bottom: 20px;
  }
  .close--form {
    position: absolute;
    top: 20px;
    right: 20px;
    width: 44px;
    cursor: pointer;
    img {
      width: 100%;
      display: block;
    }
  }
  .form-title {
    margin-top: 80px;
  }
  .form-paragraph {
    margin-top: ${props => props.theme.components_spacing_desk.regular}px;
    margin-bottom: ${props => props.theme.components_spacing_desk.xlarge}px;
  }
  .form-wrap{
    position: relative;
    width: 100%;
    margin-bottom: 60px;
  }
  .input--row{
    position: relative;
    width: 100%;
    margin-bottom: ${props => props.theme.components_spacing_desk.medium}px;
  }
  .input--row h6{
    margin-bottom: ${props => props.theme.components_spacing_desk.medium}px;
  }
  input{
    ${flexUnit(4, 28, 43, 'vw', 'font-size')};
    line-height: 130%;
    width: 100%;
    letter-spacing: -.05em;
    font-family: 'Alliance No.2', sans-serif;
    font-weight: 400;
    border: none;
    outline: transparent !important;
    border-bottom: 1px solid #000;
    &[type="file"]{
      opacity: 0;
    }
  }
  .input--wrap-row {
    position: relative;
  }
  .label {
    position: absolute;
    top: 0;
    display: block;
    pointer-events: none;
    ${flexUnit(4, 16, 28, 'vw', 'font-size')};
    line-height: 130%;
    width: 100%;
    letter-spacing: -.05em;
    font-family: 'Alliance No.2', sans-serif;
    font-weight: 400;
    border: none;
    outline: transparent !important;
    border-bottom: 1px solid #000;
    height: 100%;
    display: inline-flex;
    left: 0;
    align-items: center;
    &::before{
      content: '';
      display: inline-block;
      width: 30px;
      height: 30px;
      background-image: url("/upload-icon.png");
      background-size: 30px;
      background-repeat: no-repeat;
      padding-right: 20px;
    }
  }
  .input--wrap-row.terms--row{
    align-items: flex-start;
  }
  .check--terms{
    width: 44px;
    height: 44px;
    border: 1px solid #B3B3B3;
    flex: 0 0 44px;
    margin-right: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .check--terms img{
    display: none;
  }
  .check--terms.checked{
    background-color: ${props => props.theme.colors.green_secondary};
    border-color: ${props => props.theme.colors.green_secondary};
  }
  .check--terms.checked img{
    display: block;
    margin: 0 auto;
    flex: 0 0 24px;
    width: 24px;
  }
  .terms--row{
    color: #B3B3B3;
    display: flex;
    align-items: flex-start;
  }
  .terms--row a{
    color: ${props => props.theme.colors.green_secondary};
  }
  .check-error{
    position: absolute;
    bottom: -30px;
  }
  .error .check--terms {
    border: 1px solid #D1495B;
  }
  .error input{
    border-bottom: 1px solid #D1495B;
  }
  .error-text{
    color: #D1495B;
    padding-top: 16px;
  }
  
  .error-general {
    display: none;
  }
  .error-general.show {
    display: block;
  }
  @media screen and (max-width: 1439px){
    .overlay--wrap {
      padding-right: 40px;
      padding-left: 40px;
      width: 80%;
    }
    
  }
  @media screen and (max-width: 1023px){
    padding-bottom: ${props => props.theme.components_spacing_tablet.xxlarge}px;
    
    .form-title {
      margin-top: 80px;
    }
    .form-paragraph {
      margin-top: ${props => props.theme.components_spacing_tablet.regular}px;
      margin-bottom: ${props => props.theme.components_spacing_tablet.xlarge}px;
    }
    .input--row{
      margin-bottom: ${props => props.theme.components_spacing_tablet.medium}px;
    }
    .input--row h6{
      margin-bottom: ${props => props.theme.components_spacing_tablet.medium}px;
    }
  }
  @media screen and (max-width: 767px){
    .form-title {
      margin-top: 20px;
    }
    .form-paragraph {
      margin-top: ${props => props.theme.components_spacing_mobile.regular}px;
      margin-bottom: ${props => props.theme.components_spacing_mobile.xlarge}px;
    }
    .input--row{
      margin-bottom: ${props => props.theme.components_spacing_mobile.medium}px;
    }
    .input--row h6{
      margin-bottom: ${props => props.theme.components_spacing_mobile.medium}px;
    }
    .overlay--wrap {
      padding-right: 24px;
      padding-left: 24px;
    }
    padding-bottom: ${props => props.theme.components_spacing_mobile.xxlarge}px;
  }
`;

export {
  StyledFormOverlay,
};

